







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModItemHeader extends Vue {
  @Prop() private name!: string;

  @Prop() private requirement!: string;
}
